module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.d22f0755.svg";